/** SessionStorage key for the LogRocket config object. */
export const LR_CONFIG_KEY = 'lr_config';
/** Config version — bump when changing the LrConfig shape to force re-creation. */
export const LR_VERSION = '2';
/** LogRocket CDN script URL for dynamic loading. */
export const LR_CDN_URL = 'https://cdn.logr-in.com/LogRocket.min.js';
/** ISO-2 country codes allowed to activate LogRocket session recording. */
export const ALLOWED_COUNTRIES = new Set(['GB', 'IT', 'DE', 'ES', 'AU', 'NL', 'FR', 'US']);
